import type { TourConfig } from '../types';

export const projectsPageTour: TourConfig = {
  pageId: 'projects',
  pageName: 'Projects',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="projects-header"]',
      title: 'Projects Overview',
      intro:
        'This page lists all projects synced from the Portal. Admins see all projects; reps see only their assigned ones.',
      platform: 'both',
    },
    {
      element: '[data-tour="projects-filters"]',
      title: 'Search & Filters',
      intro:
        'Search by project name, customer, referral source, or rep. Filter by commission status, type, close date, sales rep, and referral source.',
      platform: 'both',
    },
    {
      element: '[data-tour="project-cards"]',
      title: 'Project Cards',
      intro:
        'Each card shows the project name, type, revenue, commission amount, and payment status. Linked referral sources appear in blue.',
      platform: 'both',
    },
    {
      element: '[data-tour="link-referral"]',
      title: 'Link Referral Source',
      intro:
        'For unlinked projects, click "Link referral source" to associate a company from the directory. This enables commission tracking.',
      platform: 'both',
    },
  ],
};
